import { TRIAL_PERIOD_DAYS } from "../../redux/enums";
import { Icon } from "../icons/Icon";

interface Feature {
  id: number;
  title: string;
}

const FEATURES: Feature[] = [
  { id: 1, title: "Price drop alerts on your favourite items" },
  { id: 2, title: "Favourites to quickly check your go-to items" },
  { id: 3, title: "Save unlimited lists for shops, meals & more" },
  { id: 4, title: "Push your cart to Coles or Woolies online" },
  { id: 5, title: "Shareable mobile lists for in-store shopping" },
];

const LeftContent = () => {
  return (
    <div className="u-w-all u-background--violet u-color-white u-overflow--scroll-y u-h-max--100vh u-h--100vh u-flex u-flex-center u-align-center">
      <div className="u-ph--100--desktop u-pv--48--desktop u-ph--32--mobile u-pv--24--mobile">
        <Icon id="grocerize_premium_white" width={150} height={61} />
        <div className="u-pv--16">
          <p className="u-main-font--small u-text-muted">
            Try Grocerize premium
          </p>
          <p className="u-main-font--large u-text-transform--uppercase u-bold u-pv--8">
            {TRIAL_PERIOD_DAYS} Days Free
          </p>
          <p className="u-main-font--small u-text-muted">
            Then A$2.95 per month
          </p>
        </div>

        <div className="u-pv--6">
          <h6 className="u-main-font--small u-bold">Premium Features:</h6>
          <ul className="u-list-reset">
            {FEATURES.map(({ id, title }) => (
              <li key={id} className="u-list-item--check">
                {title}
              </li>
            ))}
          </ul>
        </div>

        <div className="u-pv--24">
          <h6 className="u-main-font--small u-bold">Why Go Premium?</h6>
          <p>
            For less than a coffee a month, you unlock all the features helping
            everyday Aussies save{" "}
            <span className="u-bold">hundreds every month.</span>
          </p>
        </div>

        <div>
          <h6 className="u-main-font--small u-bold">Risk-Free Trial:</h6>
          <p className="u-pv--24">Try it free for {TRIAL_PERIOD_DAYS} days.</p>
          <h6 className="u-main-font--small u-bold">
            Cancel anytime. No charge.
          </h6>
        </div>
      </div>
    </div>
  );
};

export default LeftContent;
